import { CommonModule } from '@angular/common';
import { inject, InjectionToken, NgModule } from '@angular/core';

import { PopupService } from '../../shared/services/popup.service';
import { SharedModule } from '../../shared/shared.module';
import { PapAutoevaluationFilterComponent } from './components/pap-autoevaluation-filter/pap-autoevaluation-filter.component';
import { PapAutoevaluationRowComponent } from './components/pap-autoevaluation-row/pap-autoevaluation-row.component';
import { PapPlanFilterComponent } from './components/pap-plan-filter/pap-plan-filter.component';
import { PapPlanRowComponent } from './components/pap-plan-row/pap-plan-row.component';
import { PapPopupComponent } from './components/pap-popup/pap-popup.component';
import { PapPortfolioFilterComponent } from './components/pap-portfolio-filter/pap-portfolio-filter.component';
import { PapPortfolioRowComponent } from './components/pap-portfolio-row/pap-portfolio-row.component';
import { PapTeacherResultsComponent } from './components/pap-teacher-results/pap-teacher-results.component';
import { PapAutoEvaluationComponent } from './pages/pap-autoevaluation/pap-autoevaluation.component';
import { PapPlanComponent } from './pages/pap-plan/pap-plan.component';
import { PapPlanDetailComponent } from './pages/pap-plan-detail/pap-plan-detail.component';
import { PapPortfolioComponent } from './pages/pap-portfolio/pap-portfolio.component';
import { PapPortfolioDetailComponent } from './pages/pap-portfolio-detail/pap-portfolio-detail.component';
import { PapRoutingModule } from './pap.routing.module';
import { FormatTeacherGroupsPipe } from './pipes/format-teacher-groups/format-teacher-groups.pipe';

export const PAP_MODULE_ROOT_URL = new InjectionToken<string>('PAP_MODULE_ROOT_URL');

@NgModule({
  declarations: [
    PapPortfolioComponent,
    PapPortfolioRowComponent,
    FormatTeacherGroupsPipe,
    PapPortfolioFilterComponent,
    PapPlanComponent,
    PapPlanRowComponent,
    PapPlanFilterComponent,
    PapAutoEvaluationComponent,
    PapAutoevaluationFilterComponent,
    PapAutoevaluationRowComponent,
    PapPortfolioDetailComponent,
    PapPlanDetailComponent,
    PapTeacherResultsComponent,
    PapPopupComponent,
  ],
  imports: [CommonModule, SharedModule, PapRoutingModule],
})
export class PapModule {
  private readonly popupService = inject(PopupService);
  private readonly rootUrl = inject(PAP_MODULE_ROOT_URL);
  constructor() {
    this.popupService.manageModulePopup(this.rootUrl).subscribe((conf) => {
      if (conf.allow) {
        this.popupService.tryShowPopup('m_app_pap');
      }
    });
  }
}
